import type {
    CardPointeTerminalSaleLegacyRequestDetails,
    CardPointeTerminalSaleRequestDetails,
} from './cardpointe-terminal-sale.types';

export const CardPointeLifecyclePreflightGatewayOperation = {
    TERMINAL_SALE: 'terminal_sale',
} as const;

export type CardPointeLifecyclePreflightGatewayOperation =
    (typeof CardPointeLifecyclePreflightGatewayOperation)[keyof typeof CardPointeLifecyclePreflightGatewayOperation];

export const CardPointeLifecyclePreflightPayloadType = {
    REQUEST: 'cardpointe_lifecycle_preflight_request_v1',
    RESPONSE: 'cardpointe_lifecycle_preflight_response_v1',
} as const;

export type CardPointeLifecyclePreflightPayloadType =
    (typeof CardPointeLifecyclePreflightPayloadType)[keyof typeof CardPointeLifecyclePreflightPayloadType];

export const CardPointeLifecyclePreflightOutcome = {
    RECORDED: 'recorded',
    REJECTED: 'rejected',
    MALFORMED_INPUT: 'malformed_input',
} as const;

export type CardPointeLifecyclePreflightOutcome =
    (typeof CardPointeLifecyclePreflightOutcome)[keyof typeof CardPointeLifecyclePreflightOutcome];

export interface CardPointeLifecyclePreflightRequestDetails {
    readonly gateway_operation: typeof CardPointeLifecyclePreflightGatewayOperation.TERMINAL_SALE;
    readonly terminal_sale_request_details: CardPointeTerminalSaleRequestDetails;
}

export interface CardPointeLifecyclePreflightNormalizedResult {
    readonly gateway_operation: typeof CardPointeLifecyclePreflightGatewayOperation.TERMINAL_SALE;
    readonly merchant_id: string;
    readonly terminal_hsn: string;
    readonly amount: string;
    readonly capture: 'true';
    readonly order_id?: string;
}

export type CardPointeLifecyclePreflightResponseDetails =
    | {
          readonly outcome: typeof CardPointeLifecyclePreflightOutcome.RECORDED;
          readonly normalized_result: CardPointeLifecyclePreflightNormalizedResult;
      }
    | {
          readonly outcome: typeof CardPointeLifecyclePreflightOutcome.REJECTED;
          readonly message: string;
      }
    | {
          readonly outcome: typeof CardPointeLifecyclePreflightOutcome.MALFORMED_INPUT;
          readonly message: string;
          readonly body: unknown;
      };

export interface CardPointeLifecyclePreflightRequestPayload {
    readonly gateway_lifecycle_payload_type: typeof CardPointeLifecyclePreflightPayloadType.REQUEST;
    readonly request_details: CardPointeLifecyclePreflightRequestDetails;
}

export interface CardPointeLifecyclePreflightLegacyRequestPayload {
    readonly gateway_lifecycle_payload_type: typeof CardPointeLifecyclePreflightPayloadType.REQUEST;
    readonly request_details: {
        readonly gateway_operation: typeof CardPointeLifecyclePreflightGatewayOperation.TERMINAL_SALE;
        readonly terminal_sale_request_details: CardPointeTerminalSaleLegacyRequestDetails;
    };
}

export type StoredCardPointeLifecyclePreflightRequestPayload =
    | CardPointeLifecyclePreflightRequestPayload
    | CardPointeLifecyclePreflightLegacyRequestPayload;

export interface CardPointeLifecyclePreflightResponsePayload {
    readonly gateway_lifecycle_payload_type: typeof CardPointeLifecyclePreflightPayloadType.RESPONSE;
    readonly response_details: CardPointeLifecyclePreflightResponseDetails;
}

export type CardPointeLifecyclePreflightPayload =
    | CardPointeLifecyclePreflightRequestPayload
    | CardPointeLifecyclePreflightResponsePayload;
